export const state = () => ({
  percent: '',
  totalSteps: 100,
  profileChanged: false,
  contactsRaw: {
    tel: {
      cc: '+994 123 110255',
    },
    email: {
      cc: 'info@manato.az',
    },
  },
});

export const getters = {
  contacts(state) {
    const results = {};

    results.email = Object.entries(state.contactsRaw.email).reduce((acc, [name, value]) => {
      acc[name] = {
        link: `mailto:${value}`,
        displayed: value,
      };
      return acc;
    }, {});

    results.tel = Object.entries(state.contactsRaw.tel).reduce((acc, [name, value]) => {
      acc[name] = {
        link: `tel:${value.replace(/ -/g, '')}`,
        displayed: value,
      };
      return acc;
    }, {});

    return results;
  },

  loggedIn(...[, , { auth }]) {
    return auth.loggedIn;
  },

  user(...[, , { auth }]) {
    return auth.user;
  },

  additionalAllowed(...[, { user }]) {
    return Boolean(user.additionalAllowed) && Boolean(user.hasActiveLoan);
  },

  showCalculator(...[, { loggedIn, additionalAllowed }]) {
    return !loggedIn || (loggedIn && additionalAllowed);
  },

  notAuthorized(...[, { loggedIn, user }]) {
    return !loggedIn && Boolean(Object.keys(user).length === 0);
  },
};

export const mutations = {
  setPercent(state, percent) {
    state.percent = percent;
  },

  SET(state, { key, value }) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = value;
    }
  },
};
